import React from "react";
import PropTypes from "prop-types";
import { AlertTriangle, CircleHelp } from "lucide-react";

import Button from "./Button";
import Dialog from "./Dialog";

const ConfirmationDialog = ({
  cancelLabel = "Cancel",
  children,
  confirmLabel = "Confirm",
  description,
  loading = false,
  onCancel,
  onConfirm,
  open,
  title,
  variant = "default",
}) => {
  const Icon = variant === "destructive" ? AlertTriangle : CircleHelp;

  const actions = (
    <>
      <Button autoFocus disabled={loading} onClick={onCancel} variant="outline">{cancelLabel}</Button>
      <Button loading={loading} loadingLabel="Working..." onClick={onConfirm} variant={variant === "destructive" ? "destructive" : "primary"}>
        {confirmLabel}
      </Button>
    </>
  );

  return (
    <Dialog actions={actions} closeOnBackdrop={!loading} description={description} onClose={onCancel} open={open} size="small" title={title}>
      <div className={["wsm-confirmation", `wsm-confirmation--${variant}`].join(" ")}>
        <span className="wsm-confirmation__icon"><Icon aria-hidden="true" /></span>
        <div className="wsm-confirmation__content">{children}</div>
      </div>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  cancelLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  confirmLabel: PropTypes.string,
  description: PropTypes.string,
  loading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["default", "destructive"]),
};

export default ConfirmationDialog;
